import { computed, inject, Injectable, signal } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs'

/**
 * Native-signals replacement for `@ngneat/elf-ng-router-store`'s `RouterRepository.selectParams()`: merges route
 * params across the whole active route tree (not just the deepest activated route), refreshed on every navigation.
 */
@Injectable({ providedIn: 'root' })
export class RouteParamsService {
	private readonly router = inject(Router)
	private readonly params = signal<Record<string, string>>(this.collectParams())

	constructor() {
		this.router.events
			.pipe(
				filter((event): event is NavigationEnd => event instanceof NavigationEnd),
				takeUntilDestroyed(),
			)
			.subscribe(() => this.params.set(this.collectParams()))
	}

	param(key: string) {
		return computed(() => this.params()[key])
	}

	private collectParams(): Record<string, string> {
		let params: Record<string, string> = {}
		let route = this.router.routerState.snapshot.root
		while (route) {
			params = { ...params, ...route.params }
			if (!route.firstChild) break
			route = route.firstChild
		}
		return params
	}
}
